import styled from '@emotion/styled'

export const Subheader = styled.div`
  font-family: Satoshi;
  font-weight: 400;
  font-size: 27px;
  line-height: 40px;
  letter-spacing: 0%;
  
  @media (max-width: 768px) {
    font-size: 17px;
    text-align: center;
    line-height: 26px;
  }
`
